import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
const testimonials = [{
  name: 'Carolina M.',
  rating: 5,
  text: 'Llevaba meses sin dormir más de 2 horas seguidas. Con esta guía entendí que el problema era la asociación de sueño, no mi bebé. En una semana ya dormía tramos de 5 horas. ¡Gracias!',
  date: 'Hace 2 semanas',
  verified: true
}, {
  name: 'Valentina R.',
  rating: 5,
  text: "Lo mejor es que no te dice 'déjalo llorar'. Es respetuoso, claro y muy fácil de seguir aunque estés agotada. El planificador me ayudó a ver patrones que no notaba.",
  date: 'Hace 1 mes',
  verified: true
}, {
  name: 'Andrea P.',
  rating: 5,
  text: 'Mi bebé de 8 meses se despertaba 6 veces por noche. Apliqué las ventanas de sueño del capítulo 3 y en 4 días bajamos a 2 despertares. No lo podía creer.',
  date: 'Hace 3 semanas',
  verified: true
}, {
  name: 'Lucía G.',
  rating: 4,
  text: 'Muy completa y bien organizada. Me encantó poder ir directo al capítulo que necesitaba sin leer todo de corrido. Las regresiones del sueño me tenían loca y ahora sé qué hacer.',
  date: 'Hace 1 mes',
  verified: true
}, {
  name: 'María José T.',
  rating: 5,
  text: 'Soy mamá primeriza y esta guía me dio la seguridad que necesitaba. Ya no improviso, tengo un plan. Mi esposo también la leyó y ahora los dos sabemos qué hacer en la madrugada.',
  date: 'Hace 5 días',
  verified: true
}, {
  name: 'Daniela S.',
  rating: 5,
  text: 'El checklist de rutina nocturna cambió nuestras noches. Antes era un caos, ahora mi hija de 14 meses sabe que es hora de dormir. Totalmente recomendado.',
  date: 'Hace 2 semanas',
  verified: true
}];
function Stars({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-255">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`w-3.5 h-3.5 ${i < count ? 'text-gold fill-gold' : 'text-white/15 fill-white/15'}`} data-id="element-256" />)}
    </div>;
}
export function TestimonialsSection() {
  const avgRating = (testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length).toFixed(1);
  return <section className="py-10 md:py-20 px-4 md:px-6" data-id="element-257">
      <div className="max-w-5xl mx-auto" data-id="element-258">
        <FadeIn data-id="element-259">
          <div className="text-center mb-8 md:mb-14" data-id="element-260">
            <h2 className="text-2xl md:text-4xl font-serif mb-4 md:mb-6 text-gold" data-id="element-261">
              Lo que dicen las mamás
            </h2>

            <div className="inline-flex flex-col items-center bg-navy-card px-6 py-3 md:px-8 md:py-5 rounded-xl md:rounded-2xl shadow-sm border border-gold/10" data-id="element-262">
              <div className="flex items-center gap-2 mb-1" data-id="element-263">
                <span className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-264">
                  {avgRating}
                </span>
                <div className="flex gap-0.5" data-id="element-265">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-4 h-4 md:w-5 md:h-5 text-gold fill-gold" data-id="element-266" />)}
                </div>
              </div>
              <p className="text-xs md:text-sm text-white/50" data-id="element-267">
                Basado en{' '}
                <span className="font-medium text-white/70" data-id="element-268">
                  {testimonials.length} reseñas
                </span>{' '}
                verificadas
              </p>
            </div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6" data-id="element-269">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.06} direction="up" data-id="element-270">
              <div className={`bg-navy-card rounded-xl md:rounded-2xl p-4 md:p-6 shadow-sm border border-navy-light h-full flex flex-col ${index >= 4 ? 'hidden md:flex' : ''}`} data-id="element-271">
                <Stars count={testimonial.rating} data-id="element-272" />

                <p className="mt-3 text-white/70 leading-relaxed flex-1 text-sm md:text-[15px]" data-id="element-273">
                  "{testimonial.text}"
                </p>

                <div className="mt-3 md:mt-5 pt-3 md:pt-4 border-t border-navy-light flex items-center justify-between" data-id="element-274">
                  <div className="flex items-center gap-2 md:gap-3" data-id="element-275">
                    <div className="w-7 h-7 md:w-9 md:h-9 rounded-full bg-gold/15 flex items-center justify-center" data-id="element-276">
                      <span className="text-xs md:text-sm font-serif font-bold text-gold" data-id="element-277">
                        {testimonial.name.charAt(0)}
                      </span>
                    </div>
                    <div data-id="element-278">
                      <p className="text-xs md:text-sm font-medium text-white" data-id="element-279">
                        {testimonial.name}
                      </p>
                      <p className="text-[10px] md:text-xs text-white/30" data-id="element-280">
                        {testimonial.date}
                      </p>
                    </div>
                  </div>

                  {testimonial.verified && <div className="flex items-center gap-1 text-[10px] md:text-xs text-green-400/80" data-id="element-281">
                      <ShieldCheckIcon className="w-3 h-3 md:w-3.5 md:h-3.5" data-id="element-282" />
                      <span data-id="element-283">Verificada</span>
                    </div>}
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}